export default "__VITE_ASSET__hg$2sexw__"